import { CombineItemsCommand } from "../../core/commands/CombineItemsCommand";
import { getComponent } from "../../world/Entity";
import type { Interaction } from "../Interaction";

/** Combine a scene artifact with an inventory item. */
export const combineInteraction: Interaction = {
  id: "combine",
  label: "Combine",
  scope: "scene",
  canExecute: (ctx) => {
    if (!ctx.entity) return false;
    const artifact = getComponent(ctx.entity, "artifact");
    return artifact !== undefined && artifact.discovered;
  },
  execute: async (ctx) => {
    if (!ctx.entity) return { success: false, message: "Nothing to combine." };
    const heldItems = ctx.world.inventory.items;
    const first = heldItems[0];
    if (!first) return { success: false, message: "You have nothing to combine with." };
    ctx.commands.execute(new CombineItemsCommand(ctx.entity.id, first.instanceId));
    return { success: true };
  },
};
